// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"496":"219f305f","839":"41e6867c"}[chunkId] + ".chunk.js";
};